//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "EventCard",
  props: ["data", "ticketStartDate"],
  data() {
    return {
      // data: [{}],
    };
  },
  computed: {}
};



// WEBPACK FOOTER //
// ./scripts/vue/TicketverkoopCard.vue